import {observable, action} from 'mobx';
import {DomainStore} from 'shared/store';
import {endpoints, types} from 'main/tools';
import {TimeOffTypePolicy} from 'main/stores/time_off';

class TypePolicyModalState {
  store = new DomainStore();

  @observable typePolicy;
  @observable policy;
  @observable employee;
  @observable policySummaryAccount;

  receiveProps({timeOffTypeId, policy, employee, policySummaryAccount}) {
    this.timeOffTypeId = timeOffTypeId;
    this.policy = policy;
    this.employee = employee;
    this.policySummaryAccount = policySummaryAccount;
  }

  @action async load() {
    await this.store._compose([
      endpoints.TIME_OFF.TYPE_POLICIES.TYPE_POLICY.with(this.employee.id, this.timeOffTypeId)
    ]);

    this.typePolicy = new TimeOffTypePolicy(this.store._getSingle(types.TIME_OFF.TYPE_POLICY));
  }
}

export default TypePolicyModalState;
